<section appTitle pageTitle="Dashboard">
	<div class="statistics">
    <h1>Bildung eemol anescht</h1>
    <h2>Content Management System by <a href="https://www.edutec.lu/#home">Edutec</a></h2>
	</div>
</section>
